export default __webpack_public_path__ + "static/media/PrinzTobias.86451b0e.mov";